package ch.wsl.box.model.shared

case class ExportDef(function:String, label:String, description:Option[String], tooltip:Option[String], mode:String)
